import React from "react";
import { Progress } from "../ui/progress";

export default function StepIndicator({ steps, current }) {
  const pct = ((current + 1) / steps.length) * 100;
  return (
    <div data-testid="wizard-progress">
      <div className="flex items-center justify-between text-xs font-medium text-[hsl(var(--muted-foreground))]">
        <span>Etapa {current + 1} de {steps.length}</span>
        <span className="font-semibold" style={{ color: "hsl(var(--brand-rose))" }}>{steps[current]}</span>
      </div>
      <Progress value={pct} className="mt-2 h-2" />
    </div>
  );
}
